import { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography, Chip } from "@mui/material";

interface PixQrModalProps {
  open: boolean;
  onClose: () => void;
  payload: string;
  amountLabel: string;
  expiresAt?: string | null;
}

function formatRemaining(ms: number) {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return `${String(min).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
}

export function PixQrModal({ open, onClose, payload, amountLabel, expiresAt }: PixQrModalProps) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!open) return;
    const t = setInterval(() => setTick((x) => x + 1), 1000);
    return () => clearInterval(t);
  }, [open]);

  const expiresMs = expiresAt ? new Date(expiresAt).getTime() : NaN;
  const remainingMs = expiresMs - Date.now();
  const expired = !expiresAt || Number.isNaN(expiresMs) || remainingMs <= 0;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>QR Code PIX</DialogTitle>
      <DialogContent>
        <Stack spacing={2} alignItems="center" sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">Valor</Typography>
          <Typography variant="h6" fontWeight={700}>{amountLabel}</Typography>
          <img
            alt="PIX QRCode"
            width={220}
            height={220}
            src={`https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(payload)}`}
          />
          {expiresAt && (
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="caption" color="text.secondary">
                Tempo para pagar:
              </Typography>
              <Chip
                size="small"
                color={expired ? "default" : "warning"}
                label={expired ? "Expirado" : formatRemaining(remainingMs)}
              />
            </Stack>
          )}

          <Typography variant="caption" color="text.secondary">
            Aponte a câmera do app do seu banco para o QRCode
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
